import { useQueryClient } from '@tanstack/react-query'
import { shoppingStoresQueryOptions } from '@/features/shop/services/ShoppingStore/queries'
import { useStoreId, useUserAddressParams } from '@/features/account/services/User/hooks'

export const useIsProductSnapEbtEligible = (is_snap_ebt_eligible: boolean) => {
  const queryClient = useQueryClient()
  const addressParams = useUserAddressParams()
  const shoppingStoreData = queryClient.getQueryData(
    shoppingStoresQueryOptions(addressParams).queryKey,
  )

  const storeId = useStoreId()

  const productIsSnapEbtEligible = is_snap_ebt_eligible

  const selectedStore = productIsSnapEbtEligible
    ? shoppingStoreData?.delivery_stores.find((stores) => stores.id === storeId)
    : undefined

  return Boolean(selectedStore?.context_allows_snap)
}
